import React from 'react';

const UsersPage: React.FC = () => {
  return (
    <div></div>
  );
};

export default UsersPage;
